import { get as _get } from 'lodash'
import Component from 'vue-class-component'
import { Modal } from 'bootstrap-vue'
import { faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons'

import { Container, ContainerStatus, Item } from '@skinsoft/types'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { ItemCard } from '@skinsoft/ui'
import { LocationInput } from '@skinsoft/entity-ui/src/movement/component/movement-item-card/location-input'
import { Location } from '@skinsoft/ui/src/item-card/location'
import ContainerInput from './container-input'

require('./choose-item-modal.scss')

@Component({
    components: {
        sItemCard: ItemCard,
        sLocationInput: LocationInput,
        sContainerInput: ContainerInput,
    },
    props: ['item'],
    template: require('./choose-item-modal.html'),
})
export class ChooseItemModal extends ReactiveVue {
    public item: Item
    public selectedLocation: Location
    public locationMode = true
    public selectedContainer: Container
    public setPermanentLocation = false

    public switchOnIcon = faToggleOn
    public switchOffIcon = faToggleOff

    public containerStatusesToSearch: ContainerStatus[] = [ContainerStatus.OPEN]

    public $refs: {
        modal: Modal,
    }

    public open() {
        this.$refs.modal.show()
    }

    public onSelectedLocation(location) {
        this.selectedLocation = location
    }

    public onSelectedContainer(container) {
        this.selectedContainer = container
    }

    public confirmLocation() {
        if (this.locationMode) {
            this.$emit('location-validated', { location: this.selectedLocation, setPermanentLocation: this.setPermanentLocation })
        } else {
            this.$emit('container-validated', { container: this.selectedContainer })
        }
    }

    private get selectedItemActualContainersIds() {
        return _get(this.item, 'conditioningItemSchema.actualContainer', [])
            ?.map(actualContainer => actualContainer.container)
            .filter(id => id != undefined)
            ?? []
    }
}
